const MARKET = "u_m";
const COGNITO_USER = "cognito_user";
const LOGIN_ERRORS = "login_errors";
const USER_CLAIMS = "user_claims";
const WEB_CLIENT_LANG = "lang";
const DARK_MODE = "dark_mode";
const APP_TYPE = "app_type";
const PATHNAME = "pathname";
const RN_ICON_DELETE_CONFIRMATION = "rn_icon_delete_confirmation";

const storage = {
  MARKET,
  COGNITO_USER,
  LOGIN_ERRORS,
  USER_CLAIMS,
  WEB_CLIENT_LANG,
  DARK_MODE,
  APP_TYPE,
  PATHNAME,
  RN_ICON_DELETE_CONFIRMATION
};

export default storage;
